import {
    CREATE_PROCESS_FLOW_REQUEST,
    CREATE_PROCESS_FLOW_SUCCESS,
    CREATE_PROCESS_FLOW_FAILURE,
    DELETE_PROCESS_FLOW_REQUEST,
    DELETE_PROCESS_FLOW_SUCCESS,
    DELETE_PROCESS_FLOW_FAILURE,
    FETCH_SINGLE_PROCESS_FLOW_REQUEST,
    FETCH_SINGLE_PROCESS_FLOW_SUCCESS,
    FETCH_SINGLE_PROCESS_FLOW_FAILURE,
    FETCH_PROCESS_FLOW_REQUEST,
    FETCH_PROCESS_FLOW_SUCCESS,
    FETCH_PROCESS_FLOW_FAILURE,
    UPDATE_PROCESS_FLOW_REQUEST,
    UPDATE_PROCESS_FLOW_SUCCESS,
    UPDATE_PROCESS_FLOW_FAILURE,
    RESET_PROCESS_FLOW_INFO,
    CREATE_PROCESS_FLOW_FORM,
    UPDATE_PROCESS_FLOW_FORM,
    NAVIGATE_PROCESS_FLOW,
    NAVIGATE_PROCESS_FLOW_ADD_ON,
    NAVIGATE_PROCESS_FLOW_SUPPLIER,
    FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_SUCCESS,
    FETCH_PROCESS_FLOW_WITHOUT_ID_SUCCESS,
    FETCH_SEQUENCE_NUMBER_REQUEST,
    FETCH_SEQUENCE_NUMBER_SUCCESS,
    FETCH_SEQUENCE_NUMBER_FAILURE,
    UPDATE_PROCESS_FLOW_LISTS
} from './processFlow.actionType';

export const PROCESS_FLOW = 'processFlow';

let initialState = {
    loading: false,
    processFlowList: [],
    processFlowform: {
        fldsequenceNumber: 0
    },
    selectedState: {},
    errorMessage: '',
    singleProcessFlow: {},
    programCategory: [],
    sequenceNumber: null,
    processFlowListWithoutId: [],
    isProcessFlow: false,
    isAddOnProcess: false,
    isSupplierProcess: false
};

export let processFlowReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROCESS_FLOW_REQUEST:
        case CREATE_PROCESS_FLOW_REQUEST:
        case UPDATE_PROCESS_FLOW_REQUEST:
        case FETCH_SEQUENCE_NUMBER_REQUEST:
        case FETCH_SINGLE_PROCESS_FLOW_REQUEST:
        case DELETE_PROCESS_FLOW_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_FLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                processFlowList: updatePayload.map((x) => ({ ...x, isChecked: true, sequenceNumber: x.fldsequenceNumber, isChanged: false }))
            };
        case FETCH_PROCESS_FLOW_WITHOUT_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                processFlowListWithoutId: updatePayload
            };
        case UPDATE_PROCESS_FLOW_LISTS:
            return {
                ...state,
                loading: false,
                processFlowList: payload

            }
        case FETCH_SEQUENCE_NUMBER_SUCCESS:
            return {
                ...state,
                loading: false,
                processFlowform: {
                    fldsequenceNumber: updatePayload
                },
                sequenceNumber: updatePayload
            };
        case CREATE_PROCESS_FLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                processFlowform: {
                    fldsequenceNumber: 0
                }
            };
        case UPDATE_PROCESS_FLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                processFlowform: {
                    fldsequenceNumber: 0
                }
            };
        case FETCH_SINGLE_PROCESS_FLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                processFlowform: updatePayload
            };
        case FETCH_PROCESS_FLOW_DATA_FROM_PROPERTY_SUCCESS:
            if (payload == 41) {
                return {
                    ...state,
                    loading: false,
                    programCategory: updatePayload
                };
            } else {
                return {
                    ...state,
                    loading: false
                };
            }
        case DELETE_PROCESS_FLOW_SUCCESS:
            return {
                ...state,
                loading: false,
                processFlowform: {
                    fldsequenceNumber: 0
                }
            };
        case RESET_PROCESS_FLOW_INFO:
            return {
                ...state,
                processFlowform: { fldsequenceNumber: 'Auto Generated' }
            };
        case CREATE_PROCESS_FLOW_FORM:
        case UPDATE_PROCESS_FLOW_FORM:
            return {
                ...state,
                loading: false,
                processFlowform: {
                    ...state.processFlowform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROCESS_FLOW_FAILURE:
        case CREATE_PROCESS_FLOW_FAILURE:
        case UPDATE_PROCESS_FLOW_FAILURE:
        case FETCH_SINGLE_PROCESS_FLOW_FAILURE:
        case DELETE_PROCESS_FLOW_FAILURE:
        case FETCH_SEQUENCE_NUMBER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_PROCESS_FLOW_ADD_ON:
            return {
                ...state,
                isAddOnProcess: true,
                isSupplierProcess: false,
                isProcessFlow: false,
                singleProcessFlow: updatePayload.singleProcessFlow
            };
        case NAVIGATE_PROCESS_FLOW_SUPPLIER:
            return {
                ...state,
                isSupplierProcess: true,
                isAddOnProcess: false,
                isProcessFlow: false,
                singleProcessFlow: updatePayload.singleProcessFlow
            };
        case NAVIGATE_PROCESS_FLOW:
            return {
                ...state,
                isProcessFlow: true,
                isAddOnProcess: false,
                isSupplierProcess: false
            };
        default:
            return state;
    }
};
